import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery, useQueryClient } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetOrganizationsResponseBody } from '../OrganizationsApi.types';
import { useApi } from '~/lib/api/useApi';
import { organizationQueryKeyFactory } from './useOrganizationQuery';

export const organizationsQueryKeyFactory: IQueryKeyFactory = () =>
  ['organizations', null] as const;

export const useOrganizationsQuery = (
  options?: UseQueryOptions<IApiGetOrganizationsResponseBody, ApiError>,
): UseQueryResult<IApiGetOrganizationsResponseBody, ApiError> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: organizationsQueryKeyFactory(),
    queryFn: () => api.organizations.getAll(),
    onSuccess: (organizations) => {
      // For the moment, organizations are not paginated and not filtered, so we
      // can just set the data for app queries.
      organizations.items.forEach((organization) =>
        queryClient.setQueryData(
          organizationQueryKeyFactory({
            organizationId: organization._id,
          })!,
          organization,
        ),
      );
    },
    ...options,
  });
};
